import { close, open } from '@internetstiftelsen/styleguide/dist/molecules/modal/modal';
import delegateEvent from '@bleckert/delegate-event';

function storeConsent(share) {
	const expire = share ? Date.now() + (1000 * 60 * 60 * 24 * 365) : Date.now() + (1000 * 60 * 60 * 24 * 14);

	window.localStorage.setItem('bbk_share_position', JSON.stringify({
		share,
		expire,
	}));
}

export default function askLocationPermissions(onComplete) {
	let unsubscribe = () => {};
	let accepted = false;
	const sharePosition = JSON.parse(window.localStorage.getItem('bbk_share_position'));

	if (sharePosition && sharePosition.share && sharePosition.expire > Date.now()) {
		onComplete(true);
		return;
	}

	if (sharePosition && !sharePosition.share && sharePosition.expire > Date.now()) {
		onComplete(false);
		return;
	}

	if (sharePosition) {
		window.localStorage.removeItem('bbk_share_position');
	}

	open({
		title: 'Dela plats?',
		content: `<p>Bredbandskollen använder din position för att bland annat kunna erbjuda geografiska jämförelser av bredbandshastighet.
Läs mer om hur din position används i <a target="_blank" href="/om/avtalsvillkor/">avtalsvillkoren</a> och <a target="_blank" href="/om/om-cookies-och-datalagring/">integritetspolicyn</a>.
Du kan fortfarande mäta ditt bredband även om du inte delar din position.
Vill du dela din plats?</p>`,
		actions: [
			{
				text: 'Ja, dela',
				modifier: 'primary',
				attrs: {
					'data-share-position': null,
				},
			},
			{
				text: 'Nej, dela inte',
				color: 'transparent',
				attrs: {
					'data-modal-close': null,
				},
			},
		],
	}, {
		onClose: () => {
			storeConsent(accepted);
			onComplete(accepted);

			unsubscribe();
		},
		onOpen: () => {
			accepted = false;

			unsubscribe = delegateEvent('click', '[data-share-position]', () => {
				accepted = true;
				close();
			});
		},
	});
}
